import React from "react";
import { motion } from "framer-motion";

export function Button({ children, className = "", ...props }) {
  return (
    <motion.button
      whileTap={{ scale: 0.95 }}
      whileHover={{ scale: 1.05 }}
      className={`px-4 py-2 rounded-lg font-semibold transition-colors duration-300 focus:outline-none ${className}`}
      {...props}
    >
      {children}
    </motion.button>
  );
}
